// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"3b7e9a7a","221":"7897d26c","281":"a10ca0f2","498":"58e3805b","561":"b7916003","821":"2560ae12","878":"47b76375"}[chunkId] + ".chunk.css";
};